import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import reportWebVitals from './reportWebVitals';
import { BrowserRouter } from 'react-router-dom';
import Router from './router';
import ThemeRoot from './theme/ThemeRoot';
import { installActingUserFetch } from './utils/actingUserFetch';
import '@fontsource/outfit/300.css';
import '@fontsource/outfit/400.css';
import '@fontsource/outfit/500.css';
import '@fontsource/outfit/600.css';
import '@fontsource/outfit/700.css';

installActingUserFetch();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ThemeRoot>
      <BrowserRouter>
        <Router />
      </BrowserRouter>
    </ThemeRoot>
  </React.StrictMode>
);

reportWebVitals();
